import React from 'react';
import PropTypes from 'prop-types';
import { Popconfirm, Row, Typography } from 'antd';
import CloseIcon from 'mdi-react/CloseIcon';
import './SelectedLands.scss';

const SelectedLands = (props): JSX.Element => {
  const { talhoesSelecionados, removeSelectedField } = props;

  return (
    <div className="SelectedLands">
      <Row className="param-row">
        <div className="field-title-text" style={{ marginBottom: 8 }}>
          Talhões
        </div>
      </Row>
      <div className="selected-fields-container">
        {
          talhoesSelecionados?.map((item, index) => (
            <div
              key={`section${index + 1}`}
              className="selected-fields-item"
            >
              <span className="title-wrapper">
                <div className="title">
                  {item.name}
                </div>
                &nbsp;
                &nbsp;
                <div className="culture">
                  {item.culture ? item.culture.description : ''}
                </div>
              </span>
              {
                talhoesSelecionados.length > 1
                && removeSelectedField
                && (
                  <Popconfirm
                    title="Deseja remover o talhao?"
                    okText="Sim"
                    cancelText="Não"
                    onConfirm={
                      (): void => {
                        removeSelectedField(item.id);
                      }
                    }
                  >
                    <CloseIcon />
                  </Popconfirm>
                )
              }
              <Typography.Text className="SelectedLands__details">
                {item.details || ''}
              </Typography.Text>
            </div>
          ))
        }
      </div>
    </div>
  );
};

SelectedLands.propTypes = {
  removeSelectedField: PropTypes.func,
  talhoesSelecionados: PropTypes.arrayOf(PropTypes.any).isRequired,
};

SelectedLands.defaultProps = {
  removeSelectedField: null,
};

export default SelectedLands;
